export const colors = {
  primary: '#1c1e21',
  secondary: '#FFA500',
  secondaryDarker: '#B37300',
  accent: '#292828',
  error: '#DB4F60',
  warning: '#EB9347',
  success: '#A6D9A4',
  backgroundPrimary: '#F8F8F8',
  backgroundSecondary: '#E2ECF7',
  backgroundDark: '#191A1C',
  neutral: '#BDBDBD',
  dark: '#ABABAB',
  darkAccent: '#393838',
  green: '#84D681',
  purple: '#5E59B5',
  white: '#FFFFFF',
  startTrip: {
    outline: '#27ae60',
    fill: '#3cb637'
  },
  endTrip: {
    outline: '#c0392b',
    fill: '#e74c3c'
  },
  vtr: {
    lowConfidence: '#e74c3c',
    midConfidence: '#FFA500',
    highConfidence: '#2ecc71'
  }
};

export default colors;
